/*globals Payjp */
export const payjp = Payjp(process.env.VUE_APP_PAYJP_PUBLIC_KEY);
